<template>
  <div>
    <div class="flex flex-column mv2">
      <span class="mb2 f6 clip">Дата создания в интервале</span>
      <date-range-select v-model="dateRange" bg="light" placeholder="введите интервал"/>
    </div>

    <search-select
      class="mv2"
      :options="departments"
      v-model="department"
      placeholder="Отдел"
      :search-enabled="true"
      bg="light"
    ></search-select>

    <search-select
      class="mv2"
      :options="managers"
      v-model="manager"
      placeholder="Сотрудник"
      :search-enabled="true"
      bg="light"
    ></search-select>

    <div class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary">Приоритет</span>
      <checkbox v-for="(pri, index) in priorities" :key="index" class="mt4 mt3-l mh2"
        :label="pri.name"
        :value="pri.id"
        :checked="priorityChecked(pri.id)"
        @change="togglePriority"/>
    </div>

    <div class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary">Статус</span>
      <checkbox v-for="(stat, index) in statuses" :key="index" class="mt4 mt3-l mh2"
        :label="getStatusLabel(stat)"
        :value="stat.id"
        :checked="statusChecked(stat.id)"
        @change="toggleStatus"/>
    </div>
  </div>
</template>

<script>
import DateRangeSelect from '@/components/ui/DateRangeSelect.vue'
import SearchSelect from '@/components/ui/SearchSelect.vue'
import Checkbox from '@/components/ui/Checkbox.vue'
import { idByIndex, indexById, addUniqueToArray, removeFromArray } from '@/utils/filters.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    rootModule: {
      type: String,
      required: true
    },
    dateRangePlaceholder: {
      default: 'Интервал'
    }
  },
  components: {
    DateRangeSelect,
    SearchSelect,
    Checkbox
  },
  computed: {
    ...mapGetters('claim', [
      'claims', 'statuses', 'managers', 'departments', 'priorities', 'stats'
    ]),
    department: {
      get () {
        return indexById(this.departments, this.$store.getters[this.rootModule + '/filter/department'])
      },
      set (value) {
        this.setDepartment(idByIndex(this.departments, value))
      }
    },
    manager: {
      get () {
        return indexById(this.managers, this.$store.getters[this.rootModule + '/filter/manager'])
      },
      set (value) {
        this.setManager(idByIndex(this.managers, value))
      }
    },
    dateRange: {
      get () { return this.$store.getters[this.rootModule + '/filter/dateRange'] },
      set (value) { this.setDateRange(value) }
    }
  },
  methods: {
    // TODO: почему не работает с this.rootModule ?
    //  ...mapActions(this.rootModule + '/filter', [
    //    'setDepartment', 'setManager', 'setStatus', 'setPriority'
    //  ])
    setDepartment (dep) {
      this.$store.dispatch(this.rootModule + '/filter/setDepartment', dep)
    },
    setManager (man) {
      this.$store.dispatch(this.rootModule + '/filter/setManager', man)
    },
    setStatus (sta) {
      this.$store.dispatch(this.rootModule + '/filter/setStatus', sta)
    },
    setPriority (pri) {
      this.$store.dispatch(this.rootModule + '/filter/setPriority', pri)
    },
    setDateRange (dr) {
      this.$store.dispatch(this.rootModule + '/filter/setDateRange', dr)
    },
    priorityChecked (id) {
      return this.$store.getters[this.rootModule + '/filter/priority'].includes(id)
    },
    togglePriority (priority) {
      const id = parseInt(priority.value)
      const array = this.$store.getters[this.rootModule + '/filter/priority']
      this.setPriority(priority.checked ? addUniqueToArray(array, id) : removeFromArray(array, id))
    },
    statusChecked (id) {
      return this.$store.getters[this.rootModule + '/filter/status'].includes(id)
    },
    toggleStatus (status) {
      const id = parseInt(status.value)
      const array = this.$store.getters[this.rootModule + '/filter/status']
      this.setStatus(status.checked ? addUniqueToArray(array, id) : removeFromArray(array, id))
    },
    getStatusLabel (status) {
      const statusStats = (this.stats || {})[status.id]
      return statusStats
        ? `${status.name}(${statusStats})`
        : status.name
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
